import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	dashboardPage: {
		marginTop: '10vh',
		overflow: 'hidden',
		display: 'flex',
		width: '100%',
		height: '90vh',
		justifyContent: 'space-around !important'
	},
	sidebar: {
		flex: 1.2,
		backgroundColor: 'white',
		padding: '5.5rem 0',
		overflowY: 'scroll',
		height: '100%',
		borderRight: `1px solid ${theme.palette.secondary.grey}`
	},
	dashboardMainContent: {
		width: '100%',
		flex: 6,
		overflow: 'scroll',
		borderRadius: 'unset',
		backgroundImage: `linear-gradient(-45deg,${theme.palette.primary.lightOne},${theme.palette.secondary.grey},${theme.palette.primary.lightOne})`,
		backgroundSize: '200% 100%',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '0% 50%',
		animation: '$gradientAnimation 20s infinite'
	},
	'@keyframes gradientAnimation': {
		'0%': {
			backgroundPosition: '0% 50%'
		},
		'50%': {
			backgroundPosition: '100% 50%'
		},
		'100%': {
			backgroundPosition: '0% 50%'
		}
	},
	pageHeadingAndButtonsContainer: {
		width: '100%',
		height: '15rem',
		border: '2px solid transparent'
	},
	buttonsContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '76%',
		alignItems: 'center',
		position: 'absolute',
		top: '17vh'
	},
	circularButtonStyles: {
		borderRadius: '20px !important',
		border: '2px solid black'
	},
	categoriesContainer: {
		width: '95% !important',
		padding: '0 2rem',
		height: '80%',
		overflow: 'scroll'
	},
	categoryCard: {
		borderRadius: '5px !important',
		cursor: 'pointer',
		padding: '7rem 4rem',
		backgroundColor: 'white !important',
		textAlign: 'center',
		transition: 'all .3s ease',
		width: '25rem',
		margin: '3rem'
	},
	superAdminGrid: {
		padding: '2rem',
		textAlign: 'center',
		marginBotton: '3rem'
	},
	heading: {
		marginLeft: '2rem',
		fontWeight: '600',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center'
	},
	customTableWrapper: {
		maxHeight: '70%',
		overflow: 'auto',
		padding: '0rem',
		width: '90%',
		marginTop: '2rem',
		marginLeft: '5rem',
		backgroundColor: 'white',
		borderRadius: '5px',
		boxShadow:
			'0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'
	},
	customTableContainer: {
		borderRadius: '5px',
		width: '100%'
	},
	customTableSearch: {
		position: 'absolute !important',
		top: '16vh !important',
		right: '16%',
		width: '25% !important',
		marginBottom: '4rem !important',
		'& div': {
			borderRadius: '25px !important'
		}
	},
	customTableHead: {
		backgroundColor: theme.palette.secondary.main,
		width: '100%',
		'& div': {
			backgroundColor: theme.palette.secondary.main
		}
	},
	tabs: {
		backgroundColor: 'white !important',
		color: theme.palette.primary.grey + ' !important',
		display: 'flex !important',
		alignItems: 'center',
		marginRight: '1rem !important',
		'& svg': {
			marginTop: '.5rem'
		}
	},
	selectedTabs: {
		backgroundColor: theme.palette.primary.lightOne + ' !important',
		color: theme.palette.primary.main + ' !important',
		'& svg': {
			marginTop: '.5rem'
		}
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		},
		marginRight: '3rem'
	},
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '60rem !important',
		height: 'auto',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '2rem',
		overflowY: 'scroll'
	},
	smallButton: {
		padding: '.5rem .8rem !important',
		textTransform: 'none !important',
		width: 'fit-content !important'
	},
	superAdminModalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 'fit-content !important',
		height: 'fit-content',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '2rem',
		overflowY: 'scroll',
		display: 'flex',
		justifyContent: 'center'
	},
	superAdminModalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},
	superAdminModalHeading: {
		fontWeight: '600',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center'
	}
}));
